"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ApiNames = void 0;
var ApiNames = exports.ApiNames = {
  graphQL: 'graph_ql_api'
};